import axios from 'axios'
import { format } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import Swal from 'sweetalert2'
import '../../components/styles/common.css'
import DashboardLayout from '../../components/ui/DashboardLayout'
import Loading from '../../components/ui/Loading'
import {
  LoaderIcon,
  SavingsIcon,
  CheckCircleIcon,
  XCircleIcon,
} from '../../components/ui/Swicons'
import { devURL, greetings, titleCase } from '../../utils'
import { CircularProgressbar } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import ProfileCompletion from '../../components/ui/ProfileCompletion'
import NoTransaction from './Transfers/NoTransaction'

export default function Dashboard() {
  const token = localStorage.getItem('swToken')
  const [loader, isLoading] = useState(true)
  const [barChartData, setBarChartData] = useState([])
  const [userEmail, setUserEmail] = useState()
  const [transactionData, setTransactionData] = useState([])
  const [dashboardData, setDashboardData] = useState([])
  const [name, setName] = useState('')
  const [fav, setFav] = useState([1])
  const [greet, setGreet] = useState(' ')
  const [duration, setDuration] = useState(12)
  const [userProData, setUserProfileData] = useState([])
  const [status, setStatus] = useState('')
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    getTransactionData()
    getUserProfileData()
  }, [])

  useEffect(() => {
    getDashboardData()
  }, [duration])

  useEffect(() => {
    getFavorites()
  }, [])

  function removeDecimals(arr) {
    for (var i = 0; i < arr.length; i++) {
      arr[i].amount = parseInt(arr[i].amount.toFixed(0))
    }
  }

  const resendEmailVerify = () => {
    async function callApi() {
      await axios
        .post(
          `${devURL}/user/send-activation-email`,
          { email: userEmail },
          { headers: { token: token } }
        )
        .then((res) => {
          Swal.fire(res.data.message)
        })
        .catch((err) => {
          console.log(err)
        })
    }
    callApi()
  } //end

  const getDashboardData = () => {
    async function ApiDashCall() {
      await axios
        .get(`${devURL}/misc/get-dashboard-summary?months=` + duration, {
          headers: { token: token },
        })
        .then((res) => {
          if (res.data.status) {
            removeDecimals(res.data.summary)
            setDashboardData(res.data)
            setBarChartData(res.data.summary.reverse())
            if (res.data.length > 0 && status == 'APPROVED') {
              isLoading(false)
            }
          } else {
            if (status == 'APPROVED') {
              isLoading(false)
            }
          }
          if (status == 'APPROVED') {
            isLoading(false)
          }
        })
        .catch((err) => {
          if (status == 'APPROVED') {
            isLoading(false)
          }
          console.log(err)
        })
    }
    ApiDashCall()
  }

  const getTransactionData = () => {
    async function ApiCall() {
      await axios
        .get(`${devURL}/transfer/get`, {
          headers: { token: token },
        })
        .then((res) => {
          if (res.data.status) {
            setTransactionData(res.data.transfers)
            if (res.data.transfers.length > 0 && status == 'APPROVED') {
              isLoading(false)
            }
          } else {
            if (status == 'APPROVED') {
              isLoading(false)
            }
          }
        })
        .catch((err) => {
          if (status == 'APPROVED') {
            isLoading(false)
          }
          if (err.response.status === 401) {
            localStorage.removeItem('swToken')
            toast.error('Session expired please login again')
            return navigate('/Login')
          }
          console.log(err)
        })
    }
    ApiCall()
  }

  const getUserProfileData = () => {
    axios
      .get(`${devURL}/user/get-user-info`, {
        headers: { token: token },
      })
      .then((res) => {
        if (res.data) {
          setName(res.data.full_name)
          setUserProfileData(res.data)
          if (res.data.country == 'Unknown') {
            setGreet('Hello')
          } else {
            setGreet(greetings[titleCase(res.data.country)])
          }
          setUserEmail(res.data.email)
          if (!res.data.doc_submitted) {
            createResponse()
          } else {
            isLoading(false)
          }
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const getFavorites = () => {
    axios
      .get(`${devURL}/recipient/favorite`, {
        headers: { token: token },
      })
      .then((res) => {
        setFav(res.data.recipients)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const changeDuration = (num) => {
    setDuration(num)
  }

  const handleClickSend = (recipient) => {
    navigate('/Add-Transaction', {
      state: { ...location.state, recipient },
    })
  }

  function TopRecipients() {
    const filteredArr = fav.filter((recipient) => recipient.is_deleted !== true)
    const topThreeRecipients = filteredArr.slice(0, 3)

    return (
      <div id='recipients'>
        {topThreeRecipients.length > 0 ? (
          <div>
            {topThreeRecipients.map((recipient, index) => (
              <div
                key={recipient._id}
                className='flex justify-center text-md lg:text-base text-gray-500 font-semibold mt-6 lg:mt-2 text-center bg-gray-200 hover:bg-gray-300 rounded-full py-2 px-4 md:inline-block ml-6'
              >
                <button
                  onClick={() => handleClickSend(recipient)}
                  data-test='favourite'
                >
                  {recipient.recipient_name} ({recipient.recipient_nick_name})
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className='py-6 text-xs lg:text-sm text-center sw-cancelled w-50 lg:w-80 ml-6'>
            No recipients record was found!
          </div>
        )}
      </div>
    )
  }

  function createResponse() {
    axios
      .get(`${devURL}/user/idenfy`, {
        headers: { token: token },
      })
      .then((res) => {
        setStatus(res.data)
        isLoading(false)
      })
  }

  return (
    <DashboardLayout>
      {loader ? (
        <Loading />
      ) : (
        <div className=''>
          <div className='block mx-auto lg:flex'>
            <div className='flex justify-center lg:block lg:mx-40'>
              <h2 className='font-semibold text-3xl'>
                {greet},{' '}
                <span data-test='profile-name'>{name.split(' ', 1)}</span>
              </h2>
              <div className='hidden lg:block'>
                <p className='text-gray-400'>
                  Welcome to your personal dashboard
                </p>
              </div>
            </div>

            <ProfileCompletion userProData={userProData} />
          </div>

          <div className='hidden md:flex justify-center'>
            <div className='w-64 lg:w-full lg:flex gap-20 mt-10 justify-center'>
              <div className='col-span-2 rounded-lg shadow-lg p-6 border-t border-r '>
                <div className='pb-2'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='35'
                    height='35'
                    viewBox='0 0 640 512'
                    fill='#3084CB'
                  >
                    <path d='M535 7.03C544.4-2.343 559.6-2.343 568.1 7.029L632.1 71.02C637.5 75.52 640 81.63 640 87.99C640 94.36 637.5 100.5 632.1 104.1L568.1 168.1C559.6 178.3 544.4 178.3 535 168.1C525.7 159.6 525.7 144.4 535 135L558.1 111.1L384 111.1C370.7 111.1 360 101.2 360 87.99C360 74.74 370.7 63.99 384 63.99L558.1 63.1L535 40.97C525.7 31.6 525.7 16.4 535 7.03V7.03zM104.1 376.1L81.94 400L255.1 399.1C269.3 399.1 279.1 410.7 279.1 423.1C279.1 437.2 269.3 447.1 255.1 447.1L81.95 448L104.1 471C114.3 480.4 114.3 495.6 104.1 504.1C95.6 514.3 80.4 514.3 71.03 504.1L7.029 440.1C2.528 436.5-.0003 430.4 0 423.1C0 417.6 2.529 411.5 7.03 407L71.03 343C80.4 333.7 95.6 333.7 104.1 343C114.3 352.4 114.3 367.6 104.1 376.1H104.1zM95.1 64H337.9C334.1 71.18 332 79.34 332 87.1C332 116.7 355.3 139.1 384 139.1L481.1 139.1C484.4 157.5 494.9 172.5 509.4 181.9C511.1 184.3 513.1 186.6 515.2 188.8C535.5 209.1 568.5 209.1 588.8 188.8L608 169.5V384C608 419.3 579.3 448 544 448H302.1C305.9 440.8 307.1 432.7 307.1 423.1C307.1 395.3 284.7 371.1 255.1 371.1L158.9 372C155.5 354.5 145.1 339.5 130.6 330.1C128.9 327.7 126.9 325.4 124.8 323.2C104.5 302.9 71.54 302.9 51.23 323.2L31.1 342.5V128C31.1 92.65 60.65 64 95.1 64V64zM95.1 192C131.3 192 159.1 163.3 159.1 128H95.1V192zM544 384V320C508.7 320 480 348.7 480 384H544zM319.1 352C373 352 416 309 416 256C416 202.1 373 160 319.1 160C266.1 160 223.1 202.1 223.1 256C223.1 309 266.1 352 319.1 352z' />
                  </svg>
                </div>
                <p className='text-slate-400 text-base'>Total you sent</p>
                <p className='text-2xl mt-2 font-bold' data-test='total_sent'>
                  {loader && <LoaderIcon />}
                  {!loader && dashboardData.total_sent}
                </p>
              </div>

              <div className='col-span-2 rounded-lg shadow-lg p-6 border-t border-r mt-6 lg:mt-0'>
                <div className='pb-2'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='35'
                    height='35'
                    viewBox='0 0 24 24'
                    fill='#5084CB'
                  >
                    <path d='M12,12a3,3,0,1,0,3,3A3,3,0,0,0,12,12Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,12,16Zm-.71-6.29a1,1,0,0,0,.33.21.94.94,0,0,0,.76,0,1,1,0,0,0,.33-.21L15,7.46A1,1,0,1,0,13.54,6L13,6.59V3a1,1,0,0,0-2,0V6.59L10.46,6A1,1,0,0,0,9,7.46ZM19,15a1,1,0,1,0-1,1A1,1,0,0,0,19,15Zm1-7H17a1,1,0,0,0,0,2h3a1,1,0,0,1,1,1v8a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H7A1,1,0,0,0,7,8H4a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H20a3,3,0,0,0,3-3V11A3,3,0,0,0,20,8ZM5,15a1,1,0,1,0,1-1A1,1,0,0,0,5,15Z' />
                  </svg>
                </div>

                <p className='text-slate-400 text-base'>
                  {' '}
                  Total recipient received
                </p>
                <p className='text-2xl mt-2 font-bold'>
                  {loader && <LoaderIcon />}
                  {!loader && dashboardData.total_transferred}
                </p>
              </div>

              <div className='col-span-2 rounded-lg shadow-lg p-6 border-t border-r mt-6 lg:mt-0'>
                <div className='pb-2'>
                  <SavingsIcon />
                </div>
                <p className='text-slate-400 text-base'> Total saved</p>
                <p className='text-2xl mt-2 font-bold'>
                  {loader && <LoaderIcon />}
                  {!loader && dashboardData.total_saved}
                </p>
              </div>
            </div>
          </div>

          {userProData.is_activated ? (
            <div className='flex justify-center mt-2 md:hidden'>
              <div className='p-3 px-4 mt-8 rounded-full bg-themeColor text-white font-semibold text-lg'>
                <Link to='/Add-Transaction' className='flex items-center'>
                  Send money
                  <span className='ml-2'>
                    <svg
                      width='24px'
                      height='24px'
                      viewBox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      stroke='#ffffff'
                    >
                      <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
                      <g
                        id='SVGRepo_tracerCarrier'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                        stroke='#CCCCCC'
                        stroke-width='0.24000000000000005'
                      ></g>
                      <g id='SVGRepo_iconCarrier'>
                        <path
                          d='M2 12.0701H22'
                          stroke='#ffffff'
                          stroke-width='1.5'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                        ></path>
                        <path
                          d='M16 5L21.16 10C21.4324 10.2571 21.6494 10.567 21.7977 10.9109C21.946 11.2548 22.0226 11.6255 22.0226 12C22.0226 12.3745 21.946 12.7452 21.7977 13.0891C21.6494 13.433 21.4324 13.7429 21.16 14L16 19'
                          stroke='#ffffff'
                          stroke-width='1.5'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          ) : (
            <></>
          )}

          <div className='flex justify-center lg:block'>
            <div className='hidden lg:block chart-div mt-20'>
              <div className='lg:mx-40'>
                <h2 className='font-semibold text-3xl flex justify-center lg:block'>
                  Analytics
                </h2>
                <div className='hidden lg:block'>
                  <p className='text-gray-400'>
                    Check the total amount sent in each month
                  </p>
                </div>

                <div className='lg:flex lg:float-right lg:-mt-12'>
                  <p className=' text-gray-400 mt-4 lg:mt-1'>
                    Filter by months:{' '}
                  </p>
                  <div className='mt-6 lg:mt-0 lg:px-6 space-x-6 lg:-ml-0'>
                    <button
                      onClick={() => changeDuration(3)}
                      className='bg-themeLightColor hover:bg-themeHover w-20 rounded-md font-semibold py-1 text-white'
                    >
                      3m
                    </button>
                    <button
                      onClick={() => changeDuration(6)}
                      className='bg-themeLightColor hover:bg-themeHover w-20 rounded-md font-semibold py-1 text-white'
                    >
                      6m
                    </button>
                    <button
                      onClick={() => changeDuration(12)}
                      className='bg-themeLightColor hover:bg-themeHover w-20 rounded-md font-semibold py-1 text-white'
                    >
                      12m
                    </button>
                  </div>
                </div>
              </div>

              <div
                className='w-86 -ml-12  md:mt-20 md:m-auto md:w-3/5 -pl-24 mt-12 rounded-lg md:shadow-lg p-4'
                style={{ height: 450 }}
              >
                <ResponsiveContainer width='100%' height='100%'>
                  <BarChart
                    width={500}
                    height={300}
                    data={barChartData}
                    margin={{
                      top: 5,
                      right: 20,
                      left: 20,
                      bottom: 5,
                    }}
                    id='bar-chart'
                  >
                    <CartesianGrid vertical={false} />
                    <XAxis dataKey='month' />
                    <YAxis type='number' dataKey='amount' />
                    <Tooltip cursor={{ fill: 'transparent' }} />
                    <Bar dataKey='amount' fill='#3391e2' />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          <div className='flex justify-center lg:block'>
            <div className='mt-2 lg:ml-40 lg:mt-20'>
              <h2 className='font-semibold text-3xl mt-10 flex justify-center lg:block'>
                Favourite Recipients
              </h2>
              <div className='hidden lg:block'>
                <p className='text-gray-400'>
                  The people you send money to frequently
                </p>
              </div>
              <div className='flex justify-center lg:block gap-10 mt-4 lg:mt-10 w-4.2/5 -ml-5'>
                <TopRecipients />
              </div>
            </div>
          </div>

          <div className='lg:ml-40 mt-4 lg:mt-20 flex justify-center lg:block'>
            <h2 className='font-semibold text-3xl mt-10 '>Recent activity</h2>
            <div className='hidden lg:block'>
              <p className='text-gray-400'>Your recent transactions</p>
            </div>
          </div>
          {transactionData.length === 0 ? (
            <div className='flex justify-center items-center pt-8'>
              <NoTransaction />
            </div>
          ) : (
            <div className='flex justify-center lg:block'>
              <div className='transaction-table mt-8 ml-2 -mr-2 hidden lg:block lg:mr-6 lg:ml-6'>
                <table className='table-auto w-4/5 relative mx-auto'>
                  <thead className='border-b'>
                    <tr>
                      <th className='text-left text-gray-400 py-5 text-xs lg:text-sm'>
                        Recipient
                      </th>
                      <th className='text-left text-gray-400 py-5 text-xs lg:text-sm'>
                        You
                        <br />
                        transferred (EURO)
                      </th>
                      <th className='text-left text-gray-400 py-5 text-xs lg:text-sm'>
                        Recipient
                        <br />
                        received (INR)
                      </th>
                      <th className='text-center text-gray-400 py-5 text-xs lg:text-sm'>
                        Date
                      </th>
                      <th className='text-left text-gray-400 py-5 text-xs lg:text-sm'>
                        Rate
                      </th>
                      <th className='text-center text-gray-400 py-5 text-xs lg:text-sm w-30 '>
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactionData.length > 0 && (
                      <>
                        {transactionData.map((transaction, index) => (
                          <tr
                            key={'transaction-table-' + index}
                            className='relative hover:bg-blue-100'
                            onClick={() =>
                              navigate(
                                `/transaction-details/${transaction._id}`
                              )
                            }
                          >
                            <td
                              className='py-2 text-xs lg:text-sm text-left text-gray-800 px-2 rounded-l-lg'
                              data-test='recipient-name'
                            >
                              {titleCase(transaction.recipient_name)}
                            </td>
                            <td
                              className='py-2 text-xs lg:text-sm text-left text-gray-800'
                              data-test='recipient-sent'
                            >
                              {transaction.sent_amount.toFixed(2)}
                            </td>
                            <td className='py-2 text-xs lg:text-sm text-left text-gray-800'>
                              {transaction.received_amount.toFixed(2)}
                            </td>
                            <td className='py-2 text-xs lg:text-sm text-center text-gray-800'>
                              {format(
                                new Date(transaction.date_of_transfer),
                                'HH:mm - dd-MM-yy'
                              )}
                            </td>
                            <td className='py-2 text-xs lg:text-sm text-left text-gray-800'>
                              {transaction.rate.toFixed(2)}
                            </td>
                            <td className='py-2 text-xs lg:text-sm text-center text-gray-800 px-2 rounded-r-lg'>
                              <p
                                className={
                                  transaction.is_completed
                                    ? 'sw-completed'
                                    : transaction.raise_issue
                                    ? 'sw-unverified'
                                    : transaction.money_received &&
                                      transaction.is_vda_credited
                                    ? 'sw-verified'
                                    : transaction.user_deposit_confirmed
                                    ? 'sw-deposited'
                                    : 'sw-initiated'
                                }
                              >
                                {transaction.is_deleted
                                  ? 'Cancelled'
                                  : transaction.is_completed
                                  ? 'Completed'
                                  : transaction.raise_issue
                                  ? 'Verifying'
                                  : transaction.money_received &&
                                    transaction.is_vda_credited
                                  ? 'Verified'
                                  : transaction.user_deposit_confirmed
                                  ? 'Waiting'
                                  : 'Initiated'}
                              </p>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                    {loader && <LoaderIcon />}
                    {!loader && transactionData.length === 0 && (
                      <tr>
                        <td
                          colSpan='9'
                          className='py-6 text-xs lg:text-sm text-center sw-cancelled'
                        >
                          No recipients record was found!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {!loader && transactionData.length > 3 && (
                  <div className='flex justify-center align-middle'>
                    <Link
                      to='/Transaction-List'
                      className='text-white bg-themeLightColor hover:bg-themeHover mt-5 w-32 rounded-md py-2 px-2 text-center font-bold'
                    >
                      View more
                    </Link>
                  </div>
                )}
              </div>
              {/* Table for mobile */}
              <div className='card-container flex flex-wrap justify-center lg:hidden mt-8 ml-2'>
                {transactionData.length > 0 ? (
                  transactionData.map((transaction, index) => (
                    <div
                      key={'transaction-card-' + index}
                      className='card bg-white shadow-lg border border-t-1 m-2 p-4 rounded-lg w-4/5 lg:w-1/3 transform transition-transform duration-100 active:scale-95 active:bg-gray-100'
                      onClick={() =>
                        navigate(`/transaction-details/${transaction._id}`)
                      }
                    >
                      <div className='card-header'>
                        <div className='flex justify-between'>
                          <p className='text-gray-800 text-lg font-semibold lg:text-md block mb-2'>
                            {titleCase(transaction.recipient_name)}
                          </p>
                          <p className='text-gray-800 text-lg font-semibold lg:text-md block'>
                            {transaction.sent_amount.toFixed(2)} EUR
                          </p>
                        </div>
                        <div className='flex justify-between pt-2'>
                          <p className='text-gray-600 text-md lg:text-md block mt-1'>
                            {format(
                              new Date(transaction.date_of_transfer),
                              'HH:mm - dd-MM-yy'
                            )}
                          </p>
                          <p
                            className={
                              transaction.is_completed
                                ? 'sw-completed text-lg'
                                : transaction.raise_issue
                                ? 'sw-unverified text-lg'
                                : transaction.money_received &&
                                  transaction.is_vda_credited
                                ? 'sw-verified text-lg'
                                : transaction.user_deposit_confirmed
                                ? 'sw-deposited text-lg'
                                : 'sw-initiated text-lg'
                            }
                          >
                            {transaction.is_deleted
                              ? 'Cancelled'
                              : transaction.is_completed
                              ? 'Completed'
                              : transaction.raise_issue
                              ? 'Verifying'
                              : transaction.money_received &&
                                transaction.is_vda_credited
                              ? 'Verified'
                              : transaction.user_deposit_confirmed
                              ? 'Waiting'
                              : 'Initiated'}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='empty-card bg-white shadow-lg m-2 p-4 rounded-lg w-4/5 lg:w-1/3 text-center'>
                    <p className='text-gray-800 text-md lg:text-md'>
                      No recipients record was found!
                    </p>
                  </div>
                )}
                {loader && <LoaderIcon />}
              </div>

              {/* Mobile table end */}
            </div>
          )}
        </div>
      )}
    </DashboardLayout>
  )
}
